/**
 * Keep announcement spacer in sync with the bar's real height.
 * Bar stays pinned at top: 0; header chrome sits below via the same CSS var.
 */
(function () {
  var ro;

  function measure() {
    var ann = document.getElementById('x-announcement');
    if (!ann || ann.dataset.isSticky !== 'true') return;
    var h = ann.offsetHeight;
    document.documentElement.style.setProperty('--amc-announcement-bar-height', h + 'px');
    document.documentElement.style.setProperty('--announcement-height', h + 'px');
    ann.classList.remove('amc-ann-up', 'amc-ann-animate');
  }

  function init() {
    var ann = document.getElementById('x-announcement');
    if (!ann || ann.dataset.isSticky !== 'true') return;
    measure();
    if (typeof ResizeObserver !== 'undefined') {
      if (ro) ro.disconnect();
      ro = new ResizeObserver(measure);
      ro.observe(ann);
    } else if (ann.dataset.amcAnnSync !== 'true') {
      ann.dataset.amcAnnSync = 'true';
      window.addEventListener('resize', measure);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    var ann = document.getElementById('x-announcement');
    if (ann) delete ann.dataset.amcAnnSync;
    init();
  });
})();
